@if (isVisible()) { @if (compact) {
<aside
  class="mb-2 flex items-center gap-1 rounded-lg border border-primary/20 bg-primary/5 px-1.5 py-1 text-sm text-grey dark:text-borders-dark"
>
  <span
    aria-hidden="true"
    class="block h-2 w-2 shrink-0 bg-current mask-[url(/assets/images/icons/info.svg)] mask-center mask-no-repeat mask-size-[16px_16px]"
  ></span>
  <span>{{ "CATALOG_BETA_HINT_BODY" | translate }}</span>
</aside>
} @else {
<aside
  class="mb-3 rounded-lg border border-primary/40 bg-primary/10 px-3 py-2 text-sm"
>
  <p class="mb-0 font-semibold">
    {{ "CATALOG_BETA_HINT_TITLE" | translate }}
  </p>
  <p class="mb-0">{{ "CATALOG_BETA_HINT_BODY" | translate }}</p>
</aside>
} }
